module.exports = __webpack_public_path__ + "static/media/x-icon.a198c81a.svg";